import { render } from "./ConfigurationPanelTabContent.vue?vue&type=template&id=799a9a7d&scoped=true"
import script from "./ConfigurationPanelTabContent.vue?vue&type=script&lang=ts"
export * from "./ConfigurationPanelTabContent.vue?vue&type=script&lang=ts"

import "./ConfigurationPanelTabContent.vue?vue&type=style&index=0&id=799a9a7d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-799a9a7d"

export default script